const AUTH_KEY = 'atlas-session';

export function isAuthBypassed(): boolean {
  return (
    import.meta.env.VITE_ATLAS_AUTH_BYPASS_DEV === 'true' ||
    import.meta.env.ATLAS_AUTH_BYPASS_DEV === 'true'
  );
}

export function isAuthenticated(): boolean {
  if (isAuthBypassed()) return true;
  return sessionStorage.getItem(AUTH_KEY) === 'authenticated';
}

export function login(passphrase: string): boolean {
  if (!passphrase.trim()) return false;
  sessionStorage.setItem(AUTH_KEY, 'authenticated');
  return true;
}

export function logout(): void {
  sessionStorage.removeItem(AUTH_KEY);
}
